import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button } from '../../UI/Buttons';
import { Text } from '../../UI/Typography';
import { Textarea } from '../../UI/Inputs';
import { Modal, Overlay } from '../../UI/Containers';

const ModalHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.md};
  padding-bottom: ${({ theme }) => theme.spacing.sm};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-top: ${({ theme }) => theme.spacing.lg};
`;

const NotesModal = ({ isOpen, onClose, onSubmit, item }) => {
  const [notes, setNotes] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Reset notes when item changes or modal opens
  useEffect(() => {
    if (isOpen && item) {
      setNotes(item.notes || ''); // Pre-fill with existing notes if any
    } else if (!isOpen) {
      setNotes(''); // Clear notes when modal closes
      setIsSubmitting(false); // Reset loading state
    }
  }, [isOpen, item]);

  if (!isOpen || !item) return null;

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      // TODO: Add API call here to submit notes and potentially confirm attendance
      console.log(`Submitting notes for item ID ${item.id}:`, notes);
      await onSubmit(item.id, notes); // Wait for submission
      // Parent will handle refresh and close modal
    } catch (error) {
      console.error('Failed to submit notes:', error);
      setIsSubmitting(false); // Reset loading state on error
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !isSubmitting) {
      onClose();
    }
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <Modal maxWidth="500px">
        <ModalHeader>
          <Text size="lg" weight="semibold" style={{ margin: '0 0 4px 0' }}>
            Confirm Attendance & Add Notes
          </Text>
          <Text size="sm" color="#6b7280" style={{ margin: 0 }}>
            For: {item.full_name} ({item.date})
          </Text>
        </ModalHeader>
        
        <Textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Enter optional notes..."
          rows={4}
          style={{ marginBottom: '16px' }}
          disabled={isSubmitting}
        />
        
        <ButtonGroup>
          <Button 
            variant="outline" 
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSubmit}
            disabled={isSubmitting}
            loading={isSubmitting}
          >
            {isSubmitting ? 'Saving...' : 'Confirm & Save Notes'}
          </Button>
        </ButtonGroup>
      </Modal>
    </Overlay>
  );
};

export default NotesModal;
